import { ColorEnum } from '@/constants/color'
import { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const PrinterIcon: FC<SvgProps> = ({ fill, ...props }) => {
    return (
        <Svg viewBox="0 0 24 25" {...props} fill="none">
            <Path
                stroke={fill || ColorEnum.GRAY_900}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M7.307 14.594c-.214.027-.428.055-.64.085m.64-.085a38.43 38.43 0 0 1 9.386 0m-9.386 0-.337 3.637m9.723-3.637c.214.027.427.055.64.085m-.64-.085.337 3.637m0 0 .204 2.2a.989.989 0 0 1-.996 1.069H7.762a.988.988 0 0 1-.996-1.07l.204-2.2m10.06 0H18c1.105 0 2-.877 2-1.96v-5.488a1.91 1.91 0 0 0-1.633-1.896 43.485 43.485 0 0 0-1.7-.215M6.97 18.23H6c-1.105 0-2-.878-2-1.962v-5.487a1.91 1.91 0 0 1 1.633-1.896c.563-.083 1.13-.155 1.7-.215m9.334 0a43.98 43.98 0 0 0-9.334 0m9.334 0V5.48a.99.99 0 0 0-1-.981H8.333a.99.99 0 0 0-1 .98v3.19m10 3.022h.007v.007h-.007v-.007Zm-2.666 0h.006v.007h-.006v-.007Z"
            />
        </Svg>
    )
}

export default PrinterIcon
